export enum PdfPages {
  StaffList = "Staff List",
  ResidentsList = "Residents List"
}